import { el } from 'redom';

import SuggestionChips from '../../suggestion-chips';

function toSuggestionChip(option) {

  return {
    text: option.serializedContent,
    value: option
  };

}

class SuggestionsDisplay {

  constructor(configuration) {

    this.internetPhone = configuration.internetPhone;
    this.onSuggestionSelect = configuration.onSuggestionSelect || function noop() {};

    this.suggestionChips = new SuggestionChips({
      onSelect: this.handleSuggestionSelect.bind(this)
    });

    this.el = el('#conversation-suggestions-display-main', this.suggestionChips);

  }

  handleSuggestionSelect(option) {

    this.onSuggestionSelect();
    this.internetPhone.messageInput.setContent(option.content);

  }

  update(conversation) {

    const options = conversation.suggestion?.options || [];

    this.suggestionChips.update(options.map(toSuggestionChip));

  }

}

export default SuggestionsDisplay;
